import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { HelpCenterSettingsSupportWebsitePagesAppEntryPoint as main } from '@atlassian/jira-spa-apps-help-center-settings-support-website-pages/entrypoint.tsx';

export const HelpCenterSettingsSupportWebsitePagesAppEntryPoint = createPageEntryPoint({
	main,
	topNavigationMenuId: MENU_ID.HELP_CENTER_SETTINGS,
});
